import { toast } from "react-toastify";

/**
 * Toast notification helpers
 * Centralized toast messages with consistent styling
 */

const defaultOptions = {
  position: "bottom-right",
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: true,
};

// Success/info/warning toasts auto-close after 6 seconds
const positiveOptions = {
  ...defaultOptions,
  autoClose: 6000,
};

// Error toasts stay until manually dismissed
const errorOptions = {
  ...defaultOptions,
  autoClose: false,
};

export const showSuccess = (message, options = {}) => {
  toast.success(message, { ...positiveOptions, ...options });
};

export const showError = (message, options = {}) => {
  toast.error(message, { ...errorOptions, ...options });
};

export const showInfo = (message, options = {}) => {
  toast.info(message, { ...positiveOptions, ...options });
};

export const showWarning = (message, options = {}) => {
  toast.warning(message, { ...positiveOptions, ...options });
};

// Helper to show API error messages
export const showApiError = (error, fallbackMessage = "An error occurred") => {
  const message = error.userMessage || error.message || fallbackMessage;
  showError(message);
};
